import React from 'react'

import { Helmet } from 'react-helmet'

import './card-info.css'

// Neutral static pages for the /c/* (Gift Card) and /vip/* (VIP Card) QR routes.
//
// PERMANENTLY RESERVED ROUTES - see README "Permanently Reserved URL Paths" and
// the design docs (04_technical_design_spec.md §4.3, §26). These URLs are printed
// on physical cards that never expire.
//
// Contract for this page (04 §26.1):
// - Identical for every token: no lookup, no card state, no 404, no redirect.
// - The token in the URL is a live credential: never read it, render it, or
//   send it anywhere (any logging must redact these paths, see
//   src/utils/sanitizePath.js).
// - The MARKER_PHRASE constants are a monitored contract asserted by external
//   uptime checks. Do not reword them without updating monitoring and 04 §26.1.

export const GIFT_MARKER_PHRASE =
  'Bring the original physical Gift Card to any Lucky Claww store to redeem it.'

export const VIP_MARKER_PHRASE =
  'Present this VIP Card together with your membership QR at any Lucky Claww store.'

const StoreLocations = () => (
  <div className="card-info-stores">
    <div className="card-info-store">
      <h3>📍 Bellevue Store</h3>
      <p>
        14028 Bel-Red Rd, Unit 207
        <br />
        Bellevue, WA 98007
      </p>
    </div>
    <div className="card-info-store">
      <h3>📍 Kent Store</h3>
      <p>
        222 Washington Ave S
        <br />
        Kent, WA 98032
      </p>
    </div>
  </div>
)

export const GiftCardInfo = () => (
  <div className="card-info-container">
    <Helmet>
      <title>Lucky Claww Gift Card</title>
    </Helmet>
    <div className="card-info-panel">
      <div className="card-info-emoji">🎁</div>
      <h1>Lucky Claww Gift Card</h1>
      <p className="card-info-marker">{GIFT_MARKER_PHRASE}</p>
      <p>
        A Lucky Claww Gift Card holds one complete token package. An attendant
        will scan the card at the counter and confirm the package before
        redeeming it. Gift Cards never expire.
      </p>
      <StoreLocations />
      <p className="card-info-hours">
        Please check Google Maps for up-to-date business hours.
      </p>
      <p className="card-info-secondary">
        Looking for a digital gift card instead?{' '}
        <a href="/dashboard?section=giftcards" rel="noreferrer">
          Visit your membership dashboard
        </a>
        .
      </p>
    </div>
  </div>
)

export const VipCardInfo = () => (
  <div className="card-info-container">
    <Helmet>
      <title>Lucky Claww VIP Card</title>
    </Helmet>
    <div className="card-info-panel">
      <div className="card-info-emoji">⭐</div>
      <h1>Lucky Claww VIP Card</h1>
      <p className="card-info-marker">{VIP_MARKER_PHRASE}</p>
      <p>
        Your current VIP benefits are looked up in store. An attendant will scan
        this card together with your Lucky Claww membership QR code and show you
        the benefits available to your membership.
      </p>
      <StoreLocations />
      <p className="card-info-hours">
        Please check Google Maps for up-to-date business hours.
      </p>
    </div>
  </div>
)
